import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const renderApp = () => {
  if (window.__TURA_REACT_RENDERED__) return;
  window.__TURA_REACT_RENDERED__ = true;
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

renderApp();
